import logger from './logger';

// Session-scoped record of suppress_upsell.<label> conditions the user has
// declined. Reset on: task init (useTaskRouterWS.hooks.ts), session end
// (useSessionStatus.hooks.ts), restaurant change (resetStateForNewRestaurant
// in restaurantSlice.ts), logout (useLogout.ts), and hypothesis replay
// (useHypothesisFrames.hooks.ts — cart is rebuilt from scratch). Notably NOT
// reset on user-initiated cart clear: customer intent to suppress should stay
// consistent across that action.
let groupedUpsellDeclined: string[] = [];

export const addSuppressUpsellConditions = (conditions: string[]): void => {
  for (const cond of conditions) {
    if (!groupedUpsellDeclined.includes(cond)) {
      groupedUpsellDeclined.push(cond);
    }
  }
};

export const removeSuppressUpsellConditions = (conditions: string[]): void => {
  groupedUpsellDeclined = groupedUpsellDeclined.filter(
    (c) => !conditions.includes(c)
  );
};

export const getSuppressUpsellConditions = (): string[] =>
  groupedUpsellDeclined;

export const isSuppressedUpsell = (
  suppressUpsellConditions?: string[]
): boolean =>
  !!suppressUpsellConditions?.some((c) => groupedUpsellDeclined.includes(c));

export const resetGroupedUpsellDeclined = (): void => {
  if (groupedUpsellDeclined.length > 0) {
    logger.debug(
      `[SUPPRESS_UPSELL] reset groupedUpsellDeclined (was: ${groupedUpsellDeclined.join(
        ', '
      )})`
    );
  }
  groupedUpsellDeclined = [];
};
